/**
 * PDP: sincroniza input[name="id"] com <variant-selects>; failsafe em submit (capture);
 * is-ready no picker; libera botão após sync. Não depende de CartDrawer/pub/sub.
 */
(function () {
  if (window.__lagunaPdpVariantIdSyncInit) return;
  window.__lagunaPdpVariantIdSyncInit = true;

  function mismatchMessage() {
    return (
      window.variantStrings?.variant_reselect_before_cart ||
      window.variantStrings?.variant_selection_mismatch ||
      'Selecione o tamanho novamente antes de adicionar ao carrinho.'
    );
  }

  function parseVariants(vs) {
    const el = vs.querySelector('#ProductJson');
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function optionGroupCount(vs) {
    let n = vs.querySelectorAll(':scope > fieldset, :scope > .product-form__input').length;
    if (n) return n;
    n = vs.querySelectorAll('select[name*="options"]').length;
    if (n) return n;
    const vr = vs.querySelector('variant-radios');
    if (vr) {
      n = vr.querySelectorAll('fieldset, .product-form__input').length;
      if (n) return n;
    }
    return 0;
  }

  function getSelectedOptionValues(vs) {
    const values = [];
    vs.querySelectorAll(':scope > fieldset, :scope > .product-form__input').forEach((wrap) => {
      const sel = wrap.querySelector('select');
      if (sel && sel.selectedOptions && sel.selectedOptions[0]) {
        const value = sel.selectedOptions[0].value;
        // Ignora opção vazia inicial
        if (value !== '') {
          values.push(value);
        }
        return;
      }
      const rad = wrap.querySelector('input[type="radio"]:checked');
      if (rad) values.push(rad.value);
    });
    if (values.length) return values;

    vs.querySelectorAll('select[name*="options"]').forEach((sel) => {
      if (sel.selectedOptions && sel.selectedOptions[0]) {
        const value = sel.selectedOptions[0].value;
        // Ignora opção vazia inicial
        if (value !== '') {
          values.push(value);
        }
      }
    });
    if (values.length) return values;

    vs.querySelectorAll('input[type="radio"][name^="options"]:checked').forEach((r) => values.push(r.value));
    if (values.length) return values;

    const vr = vs.querySelector('variant-radios');
    if (vr) {
      vr.querySelectorAll('input[type="radio"]:checked').forEach((r) => values.push(r.value));
    }
    return values;
  }

  function matchVariant(variants, optionValues) {
    if (!variants || !optionValues.length) return null;
    return (
      variants.find((v) =>
        optionValues.every((val, i) => String(v['option' + (i + 1)] ?? '') === String(val))
      ) || null
    );
  }

  function showMismatchOnForm(form) {
    const msg = mismatchMessage();
    const pf = form.closest('product-form');
    if (pf?.dataset?.hideErrors === 'true') {
      window.alert(msg);
      return;
    }
    const wrap = pf?.querySelector('.product-form__error-message-wrapper');
    const msgEl = wrap?.querySelector('.product-form__error-message');
    if (wrap && msgEl) {
      msgEl.textContent = msg;
      wrap.hidden = false;
    } else {
      window.alert(msg);
    }
  }

  function releaseAwaitingInitIfSynced(productInfo, variantOk) {
    if (!variantOk || !productInfo) return;
    productInfo.querySelectorAll('product-form [type="submit"][name="add"][data-awaiting-variant-init]').forEach((btn) => {
      if (btn.hasAttribute('data-sold-out-lock')) return;
      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-disabled');
      delete btn.dataset.awaitingVariantInit;
    });
  }

  function syncVariantSelects(vs) {
    const productInfo = vs.closest('product-info');
    if (!productInfo) return;

    const forms = productInfo.querySelectorAll('form[id^="product-form-"]');
    const variants = parseVariants(vs);
    const optionValues = getSelectedOptionValues(vs);
    const groups = optionGroupCount(vs);
    
    // Se não há nenhuma opção selecionada, mantém estado de "aguardando seleção"
    if (optionValues.length === 0) {
      forms.forEach((f) => {
        f.dataset.variantReady = 'false';
        const input = f.querySelector('input[name="id"]');
        if (input) {
          input.value = '';
          input.disabled = true;
        }
      });
      vs.classList.remove('is-ready');
      return;
    }
    
    if (groups > 0 && optionValues.length !== groups) {
      forms.forEach((f) => {
        f.dataset.variantReady = 'false';
      });
      vs.classList.remove('is-ready');
      return;
    }

    const variant = matchVariant(variants, optionValues);
    if (!variant) {
      forms.forEach((f) => {
        f.dataset.variantReady = 'false';
      });
      vs.classList.remove('is-ready');
      return;
    }

    const idStr = String(variant.id);
    productInfo.querySelectorAll('form[id^="product-form-"] input[name="id"]').forEach((input) => {
      // Habilita o input quando uma variante válida é selecionada (mesmo se indisponível)
      input.disabled = false;
      input.value = idStr;
      try {
        input.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e) {}
    });

    forms.forEach((f) => {
      f.dataset.variantId = idStr;
      f.dataset.variantReady = 'true';
      // Marca se a variante está disponível ou não
      f.dataset.variantAvailable = variant.available ? 'true' : 'false';
    });

    vs.classList.add('is-ready');
    releaseAwaitingInitIfSynced(productInfo, true);
  }

  function validateFormVariant(form) {
    const pi = form.closest('product-info');
    const vs = pi?.querySelector('variant-selects');
    if (!vs) return { ok: true };

    const variants = parseVariants(vs);
    const optionValues = getSelectedOptionValues(vs);
    const groups = optionGroupCount(vs);
    if (groups > 0 && optionValues.length !== groups) return { ok: false };

    const variant = matchVariant(variants, optionValues);
    const idInput = form.querySelector('input[type="hidden"][name="id"]');
    if (!idInput || idInput.disabled) return { ok: true };
    if (!variant) return { ok: false };
    return { ok: String(variant.id) === String(idInput.value) };
  }

  document.addEventListener(
    'submit',
    function (e) {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.getAttribute('data-type') !== 'add-to-cart-form') return;
      // Não usar form.id: <input name="id"> expõe-se como form.id (elemento), não o atributo id do <form>.
      const formElId = form.getAttribute('id') || '';
      if (!formElId || formElId.indexOf('product-form-') !== 0) return;
      const pi = form.closest('product-info');
      if (!pi || !pi.querySelector('variant-selects')) return;

      const { ok } = validateFormVariant(form);
      if (ok) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      showMismatchOnForm(form);
    },
    true
  );

  function onInteraction(ev) {
    const vs = ev.target.closest && ev.target.closest('variant-selects');
    if (!vs) return;
    vs.classList.remove('is-ready');
    syncVariantSelects(vs);
    requestAnimationFrame(() => syncVariantSelects(vs));
  }

  document.addEventListener('change', onInteraction, true);
  document.addEventListener('click', onInteraction, true);

  document.addEventListener('product-info:loaded', (ev) => {
    const el = ev.target;
    if (!el || !el.querySelector) return;
    const vs = el.querySelector('variant-selects');
    if (vs) {
      vs.classList.remove('is-ready');
      syncVariantSelects(vs);
      requestAnimationFrame(() => syncVariantSelects(vs));
    }
  });

  function initAll() {
    document.querySelectorAll('variant-selects').forEach((vs) => {
      vs.classList.remove('is-ready');
      // Força estado inicial desabilitado se não houver seleção
      const productInfo = vs.closest('product-info');
      if (productInfo) {
        const optionValues = getSelectedOptionValues(vs);
        if (optionValues.length === 0) {
          productInfo.querySelectorAll('form[id^="product-form-"]').forEach((f) => {
            f.dataset.variantReady = 'false';
            const input = f.querySelector('input[name="id"]');
            if (input) {
              input.value = '';
              input.disabled = true;
            }
          });
        }
      }
      syncVariantSelects(vs);
      requestAnimationFrame(() => syncVariantSelects(vs));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
